import React, { useState } from 'react'

import * as Yup from 'yup'
import * as auth from '../redux/AuthRedux';
import { useHistory } from 'react-router-dom';

import { Button, Input, Form, message, Image, Card, Divider } from 'antd';
/* eslint-disable jsx-a11y/anchor-is-valid */

import { login } from '../redux/AuthCRUD'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import { useIntl } from 'react-intl'
import './../../../assets/scss/style.scss';
import { LockOutlined, UserOutlined } from '@ant-design/icons';

import Logo_ssc from '../../../assets/images/Logo_ssc.png';
import Logo_evision from '../../../assets/images/Logo_evision.png';
import Logo_song from '../../../assets/images/Logo_song.png';
import Logo_hapu from '../../../assets/images/Logo_hapu.png';
import Logo_aha from '../../../assets/images/Logo_aha.png';
import Logo_max_media from '../../../assets/images/Logo_max_media.png';
import Logo_quangtri from '../../../assets/images/Logo_quangtri.png';
import Logo_loc from '../../../assets/images/Logo_loc.png';
import Logo_aha_manual from '../../../assets/images/Logo_aha_manual.png';

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Sai định dạng Email')
    .min(3, 'Ít nhất 3 kí tự ')
    .max(50, 'Nhiều nhất 50 kí tự')
    .required('Trường không để trống'),
  password: Yup.string()
    .min(8, 'Mật khẩu ít nhất 8 kí tự ')
    .max(50, 'Nhiều nhất 50 kí tự')
    .required('Trường không để trống'),
});

const initialValues = {
  email: '',
  password: '',
};

let vendor = process.env.REACT_APP_VENDOR;

export function Login() {
  const intl = useIntl();

  const history = useHistory();

  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setTimeout(() => {
        login(values.email, values.password)
          .then((res: any) => {
            const data = res.data;
            console.log('---- data login nè ---', data);
            setLoading(false)
            if (data?.error) {
              setStatus(data?.data?.message)
              messageApi.warning(data?.error);
            } else {
              messageApi.success('Thành công');
              dispatch(auth.actions.login('Bearer ' + data?.data?.token))
            }
            setSubmitting(false)
          }).catch((e) => {
            console.log('login', e);
            messageApi.error('Thông tin đăng nhập không đúng');
            setLoading(false)
            setSubmitting(false)
            setStatus('Thông tin đăng nhập không đúng')
          })
      }, 1000);
    },
  });

  return (
    <>
      {contextHolder}
      <form
        className='form w-100'
        onSubmit={formik.handleSubmit}
        noValidate
        id='kt_login_signin_form'
      >
        <div className="auth-wrapper">
          <div className="auth-content">
            <div className="auth-bg">
              <span className="r" />
              <span className="r s" />
              <span className="r s" />
              <span className="r" />
            </div>
            <Card style={{ borderRadius: '10px' }}>
              <div className="mb-3" style={{ display: 'inline-flex', alignItems: 'center' }}>
                {
                  vendor === 'ssc' ? (
                    <Image preview={false} style={{ borderRadius: '5px' , width: '30px'}} src={Logo_ssc}/>
                  ) : vendor === 'evision' ? (
                    <Image preview={false} style={{ borderRadius: '5px' , width: '30px'}} src={Logo_evision}/>
                  ) : vendor === 'aha' ? (
                    <Image preview={false} style={{ borderRadius: '5px' , width: '30px'}} src={Logo_aha}/>
                  ) : vendor === 'hapu' ? (
                    <Image preview={false} style={{ borderRadius: '5px' , width: '30px'}} src={Logo_hapu}/>
                  ) : vendor === 'max_media' ? (
                    <Image preview={false} style={{ borderRadius: '5px' , width: '30px'}} src={Logo_max_media}/>
                  ) : vendor === 'loc' ? (
                    <Image preview={false} style={{ borderRadius: '5px' , width: '30px'}} src={Logo_loc}/>
                  ) : vendor === 'aha_manual' ? (
                    <Image preview={false} style={{ borderRadius: '5px' , width: '30px'}} src={Logo_aha_manual}/>
                  ) : vendor === 'quangtri' ? (
                    <Image preview={false} style={{ borderRadius: '5px' , width: '30px'}} src={Logo_quangtri}/>
                  ) : (
                    <Image preview={false} style={{ borderRadius: '5px' , width: '30px'}} src={Logo_song}/>
                  )
                }
                <span className='b-title text-black ml-3' style={{ fontSize: '17px' }}>{process.env.REACT_APP_NAME}</span>
              </div>
              <Divider className='mt-0 mb-3 p-0' />
              <span className='pt-2 pb-2'>
                <h4 className="mb-1 text-left">Đăng nhập</h4>
                <p className='text-black-50 text-left text-xs'>
                  {intl.formatMessage({ id: 'AUTH.LOGIN.DESC' })}
                </p>
              </span>
              <Form.Item
                hasFeedback
                name="email"
                validateStatus={(formik.touched.email && formik.errors.email) ? "error" : ""}
              >
                <Input
                  size="large"
                  placeholder="xxxxxxx@xxxxx.xxx"
                  prefix={<UserOutlined rev={undefined} />}
                  {...formik.getFieldProps('email')}
                  type='email'
                  name='email'
                  autoComplete='off'
                />
                <div className="input-group">
                  {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.email}</span>
                      </div>
                    </div>
                  )}
                </div>
              </Form.Item>
              <Form.Item
                hasFeedback
                name="password"
                validateStatus={(formik.touched.password && formik.errors.password) ? "error" : ""}
              >
                <Input.Password
                  size="large"
                  placeholder='Nhập vào mật khẩu'
                  prefix={<LockOutlined rev={undefined} />}
                  type='password'
                  autoComplete='off'
                  {...formik.getFieldProps('password')}
                />
                <div className="input-group">
                  {formik.touched.password && formik.errors.password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.password}</span>
                      </div>
                    </div>
                  )}
                </div>
              </Form.Item>

              <Button
                size='large'
                className='btn-block text-uppercase font-weight-bold font-size-sm'
                type="primary"
                color={loading ? 'secondary' : ''}
                loading={loading}
                htmlType='submit'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {intl.formatMessage({ id: 'AUTH.LOGIN.BUTTON' })}
              </Button>
              <Button
                size='large'
                className='btn-block text-uppercase font-weight-bold font-size-sm'
                type="ghost"
                onClick={() => history.push(`/auth/registration`)}
              >
                {intl.formatMessage({ id: 'AUTH.GENERAL.NO_ACCOUNT' })}&nbsp;
              </Button>
            </Card>
          </div>
        </div>
      </form>
    </>
  )
}
